// @flow strict
type Cookies = {|
  CURRENCY: string,
  DATE: string,
  GROUP_REVIEWS_EXPERIMENT: string,
  VIEWER_COUNTRY: string,
|};

// keep name short
export const COOKIES: Cookies = {
  CURRENCY: 'cur',
  DATE: 'date',
  GROUP_REVIEWS_EXPERIMENT: 'tl_exp_group_reviews_v1',
  VIEWER_COUNTRY: 'viewer_country',
};

// expiration 1 year
export const COOKIE_OPTIONS = {
  expires: 365,
};
